import { sx } from '../../../lib/sx'
import type { Vals } from '../../../demo/vals'

export function Monitor({ v }: { v: Vals }) {
  return (
    <div style={sx("position:absolute;inset:0;padding-top:64px;display:flex;flex-direction:column")}>
      <div style={sx("padding:0 20px 22px;display:flex;align-items:center;justify-content:space-between;gap:12px")}>
        <span style={sx("font-size:var(--fs-5xl);font-weight:var(--fw-bold);letter-spacing:var(--ls-sm)")}>
          Monitor
        </span>
      </div>
      <div style={sx("flex:1;overflow:auto;padding:0 20px 20px;display:flex;flex-direction:column;gap:12px")}>
        {v.memberHasBreach ? (
          <div
            style={sx(
              "padding:18px;border-radius:var(--radius-lg);background:var(--bg-secondary);" +
                "border:1px solid var(--border-critical);display:flex;flex-direction:column;gap:12px;" +
                "animation:gpop 250ms var(--ease-out)"
            )}
          >
            <span style={sx("display:flex;align-items:center;gap:12px")}>
              <span
                style={sx(
                  "width:40px;height:40px;flex:none;border-radius:var(--radius-full);" +
                    "background:var(--bg-critical-subtle);display:flex;align-items:center;justify-content:center"
                )}
              >
                <span
                  style={sx(
                    "width:20px;height:20px;background:var(--text-critical);" +
                      "-webkit-mask:url(/assets/icons/security-score.svg) center/contain no-repeat;" +
                      "mask:url(/assets/icons/security-score.svg) center/contain no-repeat"
                  )}
                />
              </span>
              <span style={sx("flex:1;display:flex;flex-direction:column;gap:2px;min-width:0")}>
                <span style={sx("font-size:var(--fs-md);font-weight:var(--fw-medium)")}>
                  {v.memberBreachCount} breach found
                </span>
                <span style={sx("font-size:var(--fs-xs);color:var(--text-critical)")}>
                  Change this password now
                </span>
              </span>
            </span>

            {v.memberBreaches.map((b, i) => (
              <span
                key={i}
                style={sx(
                  "padding:12px 14px;border-radius:var(--radius-md);background:var(--bg-tertiary);" +
                    "display:flex;flex-direction:column;gap:3px"
                )}
              >
                <span style={sx("display:flex;justify-content:space-between;gap:8px;align-items:baseline")}>
                  <span style={sx("font-size:var(--fs-sm);font-weight:var(--fw-medium)")}>
                    {b.service}
                  </span>
                  <span style={sx("font-size:var(--fs-2xs);color:var(--text-secondary);flex:none")}>
                    {b.time}
                  </span>
                </span>
                <span style={sx("font-size:var(--fs-xs);color:var(--text-secondary)")}>
                  {b.leaked}
                </span>
                <span style={sx("font-size:var(--fs-2xs);color:var(--text-disabled)")}>
                  {b.when}
                </span>
              </span>
            ))}
          </div>
        ) : (
          <div
            style={sx(
              "padding:20px 18px;border-radius:var(--radius-lg);background:var(--bg-secondary);" +
                "border:1px solid var(--border-secondary);display:flex;flex-direction:column;" +
                "align-items:center;gap:8px;text-align:center"
            )}
          >
            <span
              style={sx(
                "width:56px;height:56px;border-radius:var(--radius-full);" +
                  "background:var(--bg-success-subtle);display:flex;align-items:center;justify-content:center"
              )}
            >
              <span
                style={sx(
                  "width:26px;height:26px;background:var(--text-success);" +
                    "-webkit-mask:url(/assets/icons/security-score.svg) center/contain no-repeat;" +
                    "mask:url(/assets/icons/security-score.svg) center/contain no-repeat"
                )}
              />
            </span>
            <span style={sx("font-size:var(--fs-md);font-weight:var(--fw-medium)")}>
              No breaches found
            </span>
            <span style={sx("font-size:var(--fs-xs);line-height:18px;color:var(--text-secondary)")}>
              Last checked 4 minutes ago. We'll tell you the moment something shows up.
            </span>
          </div>
        )}
        <span style={sx("font-size:var(--fs-xs);font-weight:var(--fw-medium);color:var(--text-secondary);letter-spacing:.04em;text-transform:uppercase")}>
          Monitored
        </span>
        <div style={sx("display:flex;flex-direction:column;gap:8px")}>
          <div style={sx("padding:14px 16px;border-radius:var(--radius-md);background:var(--bg-secondary);border:1px solid var(--border-secondary);display:flex;align-items:center;gap:12px")}>
            <span style={sx("width:18px;height:18px;flex:none;background:var(--text-primary);-webkit-mask:url(/assets/icons/email.svg) center/contain no-repeat;mask:url(/assets/icons/email.svg) center/contain no-repeat")} />
            <span style={sx("font-size:var(--fs-sm);flex:1")}>
              Email address
            </span>
            <span style={sx("font-size:var(--fs-xs);color:var(--text-secondary)")}>
              1 monitored
            </span>
          </div>
          <div style={sx("padding:14px 16px;border-radius:var(--radius-md);background:var(--bg-secondary);border:1px solid var(--border-secondary);display:flex;align-items:center;gap:12px")}>
            <span style={sx("width:18px;height:18px;flex:none;background:var(--text-primary);-webkit-mask:url(/assets/icons/account.svg) center/contain no-repeat;mask:url(/assets/icons/account.svg) center/contain no-repeat")} />
            <span style={sx("font-size:var(--fs-sm);flex:1")}>
              Phone number
            </span>
            <span style={sx("font-size:var(--fs-xs);color:var(--text-secondary)")}>
              1 monitored
            </span>
          </div>
          <div style={sx("padding:14px 16px;border-radius:var(--radius-md);background:var(--bg-secondary);border:1px solid var(--border-secondary);display:flex;align-items:center;gap:12px")}>
            <span style={sx("width:18px;height:18px;flex:none;background:var(--text-primary);-webkit-mask:url(/assets/icons/lock.svg) center/contain no-repeat;mask:url(/assets/icons/lock.svg) center/contain no-repeat")} />
            <span style={sx("font-size:var(--fs-sm);flex:1")}>
              Credit card
            </span>
            <span style={sx("font-size:var(--fs-xs);color:var(--text-secondary)")}>
              2 monitored
            </span>
          </div>
        </div>
      </div>
      <div style={sx("height:82px;flex:none;border-top:1px solid var(--border-secondary);background:var(--bg-secondary);display:flex;align-items:flex-start;padding:12px 8px 0")}>
        <button onClick={v.kTabConnect} style={sx("flex:1;background:none;border:none;cursor:pointer;display:flex;flex-direction:column;align-items:center;gap:5px;font-family:inherit")}>
          <span style={sx("width:24px;height:24px;background:var(--text-secondary);-webkit-mask:url(/assets/icons/nav-globe.svg) center/contain no-repeat;mask:url(/assets/icons/nav-globe.svg) center/contain no-repeat")} />
          <span style={sx("font-size:var(--fs-2xs);color:var(--text-secondary)")}>
            Connect
          </span>
        </button>
        <button onClick={v.kTabProtect} style={sx("flex:1;background:none;border:none;cursor:pointer;display:flex;flex-direction:column;align-items:center;gap:5px;font-family:inherit")}>
          <span style={sx("width:24px;height:24px;background:var(--text-secondary);-webkit-mask:url(/assets/icons/nav-threat.svg) center/contain no-repeat;mask:url(/assets/icons/nav-threat.svg) center/contain no-repeat")} />
          <span style={sx("font-size:var(--fs-2xs);color:var(--text-secondary)")}>
            Protect
          </span>
        </button>
        <button onClick={v.kTabMonitor} style={sx("flex:1;background:none;border:none;cursor:pointer;display:flex;flex-direction:column;align-items:center;gap:5px;font-family:inherit")}>
          <span style={sx("width:24px;height:24px;background:var(--text-accent);-webkit-mask:url(/assets/icons/security-score.svg) center/contain no-repeat;mask:url(/assets/icons/security-score.svg) center/contain no-repeat")} />
          <span style={sx("font-size:var(--fs-2xs);color:var(--text-accent);font-weight:var(--fw-medium)")}>
            Monitor
          </span>
        </button>
      </div>
    </div>
  )
}
